// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__3L0NJ","rotation":"styles_rotation__2_0Fa","rotationBack":"styles_rotationBack__3Vocr"};